// Builds the Calendly inline-embed URL with prefill params (name, first/last name, email, phone as a1).
export function calendlyUrl(base, hideDetails, prefill = {}) {
  if (!base) return base;
  const u = new URL(base);
  if (hideDetails) ["hide_event_type_details", "hide_landing_page_details", "hide_gdpr_banner"].forEach((k) => u.searchParams.set(k, "1"));
  const first = String(prefill.firstName || "").trim();
  const last = String(prefill.lastName || "").trim();
  const name = [first, last].filter(Boolean).join(" ") || String(prefill.name || "").trim();
  if (name) u.searchParams.set("name", name);
  if (first) u.searchParams.set("first_name", first);
  if (last) u.searchParams.set("last_name", last);
  if (prefill.email) u.searchParams.set("email", String(prefill.email).trim());
  if (prefill.phone) u.searchParams.set("a1", String(prefill.phone).trim());
  return u.toString();
}
